var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRpIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4772 4.02539V7.98373C13.4772 8.19369 13.5606 8.39505 13.7091 8.54352C13.8576 8.69199 14.0589 8.77539 14.2689 8.77539H18.2272M13.4772 4.02539C13.7278 4.02499 13.976 4.07416 14.2076 4.17009C14.4391 4.26601 14.6493 4.40679 14.8262 4.58431L17.6667 7.42481C17.8447 7.60175 17.9859 7.81221 18.0821 8.04402C18.1783 8.27583 18.2276 8.52441 18.2272 8.77539M13.4772 4.02539H7.14388C6.72395 4.02539 6.32123 4.19221 6.02429 4.48914C5.72736 4.78607 5.56055 5.1888 5.56055 5.60873L5.56055 12.1902M18.2272 8.77539V18.2754C18.2272 18.6953 18.0604 19.098 17.7635 19.395C17.4665 19.6919 17.0638 19.8587 16.6439 19.8587H13.3331",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23268 21.8423L7.24929 20.9117M5.28748 20.0584L4.61684 20.7056M4.50339 18.0672L3.5724 18.0515M9.24044 20.1276L9.88761 20.7982M5.35665 16.1054L4.71033 15.4352M11.0252 18.1827L10.0937 18.1658M7.34816 15.3205L7.36355 14.3904M9.30997 16.1738L9.97987 15.5283M8.41324 15.5531C9.82893 16.1689 10.4774 17.8157 9.86169 19.2313C9.24595 20.647 7.59916 21.2955 6.18346 20.6798C4.76777 20.0641 4.11927 18.4173 4.73501 17.0016C5.35074 15.5859 6.99754 14.9374 8.41324 15.5531Z",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0509,
    height: 24.0509,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpIconLight);
export default __webpack_public_path__ + "static/media/RP Icon - Light.eb973e704172ac3ad6ca9b3e4a064b74.svg";
export { ForwardRef as ReactComponent };